import { IBillPackage } from '@/@types/bill-package'
import { ColumnHeader } from '@/components/data-table/column-header'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { Coins } from 'lucide-react'

export const TABLE_COLUMNS: ColumnDef<IBillPackage>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: ({ column }) => <ColumnHeader column={column} title="Nome" />,
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        <Coins className="max-w-6 text-primary" />
        <span>{row.original.name}</span>
      </div>
    ),
    filterFn: (row, id, value) =>
      String(row.getValue(id))
        .toLowerCase()
        .includes(String(value).toLowerCase()),
  },
  {
    id: 'price',
    accessorKey: 'price',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Custo (MZN)" />
    ),
    cell: ({ row }) =>
      `${Number(row.original.price).toLocaleString('pt-PT')} MZN`,
  },
  {
    id: 'expirationDays',
    accessorKey: 'expirationDays',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Validade (dias)" />
    ),
    cell: ({ row }) =>
      row.original.expirationDays != null
        ? `${row.original.expirationDays} dias`
        : '30 (padrão)',
  },
  {
    id: 'createdAt',
    accessorKey: 'createdAt',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Data de criacao" />
    ),
    cell: ({ row }) =>
      row.original.createdAt
        ? format(row.original.createdAt, 'dd/MM/yyyy')
        : '-',
  },
]
